import React from "react";
import { useAppMediaProvider } from "baseStyles/AppMediaProvider";
import { useSuiTheme } from "baseStyles/ThemeProvider";
import Device from "baseStyles/enums/device";
import { useMemo } from "react";
import DataUtility from "utility/data";
import { ITheme, ThemesName } from "baseStyles/ThemeProvider/themes";

const mediaStyleOrder = [Device.types.Desktop, Device.types.Tablet, Device.types.Mobile, Device.types.Mobile]

export type SuiStyleFunction<I, O> = (props?: I & { theme?: ITheme, themeName?: ThemesName }) => O;

export type SuiStylesType<I, O> = {
    [k in Device.types]?: SuiStyleFunction<I, O>
}

export const useSuiStyles = <I, O>(styles: SuiStylesType<I, O>): SuiStyleFunction<I, O> => {
    // console.log("useSuiStyles Init");

    return (props) => {
        const { currentDevice } = useAppMediaProvider();
        const { theme, themeName } = useSuiTheme();

        // console.log("useSuiStyles", props, currentDevice, theme, themeName);

        const desktopStyles =  useMemo(() => styles.desktop?.({ ...props, theme, themeName }), [props, theme, currentDevice]);
        const currentDeviceStyles = useMemo(() => styles[currentDevice]?.({ ...props, theme, themeName }), [props, theme, currentDevice]);
        let finalStyles = useMemo(() => {
            const currentOrder = mediaStyleOrder.findIndex(item => item === currentDevice);
            let data = desktopStyles;
            for(let i=1; i <= currentOrder; i++) {
                data =  DataUtility.deepMerge(data, styles[mediaStyleOrder[i]]?.({ ...props, theme, themeName }));
            }
            return data;
        }, [desktopStyles, currentDeviceStyles]);

        return finalStyles;
    }
}